import React from 'react'

const BkFlowNavigationDetailsLocationContact = props => {
	const {
		parentClasses,
		disableContactLabel,
		contactLabel,
		contactType,
		contactValue
	} = props

	let currentType = 'tel:'

	if (contactType === 'email') {
		currentType = 'mailto:'
	}

	return (
		<div className={ parentClasses ?
			'bk-flow-navigation-details__location-row ' + parentClasses
		:
			'bk-flow-navigation-details__location-row'
		}>
			{ !disableContactLabel && <p className="label u-remove-margin">{ contactLabel }:&nbsp;</p> }
			<a
				className="value"
				href={ currentType + contactValue }
				tabIndex={-1}
			>
				{ contactValue }
			</a>
		</div>
	)
}

export default BkFlowNavigationDetailsLocationContact



// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationDetailsLocationContact.js